module.exports = __webpack_public_path__ + "static/media/test-company-logo.8ab06198.jpg";